import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { FormikSwitch } from "../../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

import { CompanyUserFormValues } from "../../companyUserFormTypes"

const useStyles = makeStyles()((theme) => ({
    description: {
        color: theme.palette.tailwind.slate[500],
    },
}))

export function GuestCheckInTab() {
    const { classes } = useStyles()

    return (
        <Stack direction="column" spacing="1rem">
            <LocalizedStrict id="company-user-guest-checkin-description">
                <Typography variant="body2" className={classes.description}>
                    Choose whether this user is notified when a guest checks in.
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="company-user-guest-checkin-toggle">
                <FormikSwitch<CompanyUserFormValues> name="notifyOnGuestArrival">Notify on guest check-in</FormikSwitch>
            </LocalizedStrict>
        </Stack>
    )
}
